<template>
  <v-container>
    <v-row no-gutters>
      <div>
        <img :src="logoCompuesto" alt="Facultad de Química UNAM" />
      </div>
      <v-spacer></v-spacer>
      <div class="white--text departamento">
        Programa de Estancias Cortas de Investigación
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      logoCompuesto: require("@/assets/logoCompuesto.png"),
    };
  },
};
</script>

<style scoped>
.departamento {
  max-width: 15rem;
  display: flex;
  justify-content: left;
  align-items: center;
  text-align: right;
  font-size: 22px;
}
</style>